import React, { Component } from "react";
import axios from 'axios';
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { green, yellow } from "@material-ui/core/colors";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  RadioGroup,
  Slider,
  Snackbar,
  TextField,
  Typography,
  withStyles
} from "@material-ui/core";
import Form from "react-bootstrap/Form";
import { Alert } from "@material-ui/lab";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Paper from "@material-ui/core/Paper";
import "./MakeEntry.css";
import moment from "moment";

const SwalJsx = withReactContent(Swal);

const GreenRadio = withStyles({
  // turns the radio button green
  root: {
    color: green[400],
    "&$checked": {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);

const YellowRadio = withStyles({
  // turns the radio button yellow
  root: {
    color: yellow[400],
    "&$checked": {
      color: yellow[600],
    },
  },
  checked: {},
})((props) => <Radio color="default" {...props} />);




class EntryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parent_lcf_id: props.parent_lcf_id,

      //state info for entry form
      lcf_id: props.parent_lcf_id,
      entry_id: null,
      pass_class: "",
      gpa: 0,
      days_clean_attend: 0,
      total_days: 10,
      had_detention: null,
      act_or_job: null,
      substance_abuse: null,
      service_hrs_met: null,
      hw_rm_attended: null,
      comments: '',
      //error values used to conditionally render error toasts, default is false
      isSaving: false,
      error: false,
      api_error: false,
      pay_day_error: false,
      dupeEntry: false,
      toggle: false,
      backButtonFunc: props.backButtonFunc ? props.backButtonFunc
        : () => {this.props.history.goBack()}
    };
    if (props.stu_entry) {
      this.state.gpa = this.props.stu_entry.gpa;
      this.state.entry_id = this.props.stu_entry.id;
      this.state.days_clean_attend = this.props.stu_entry.days_clean_attend;
      this.state.pass_class = this.props.stu_entry.pass_class ? "Yes" : "No";
      this.state.had_detention = this.props.stu_entry.had_detention ? "Yes" : "No";
      this.state.act_or_job = this.props.stu_entry.act_or_job ? "Yes" : "No";
      this.state.substance_abuse = this.props.stu_entry.substance_abuse ? "Yes" : "No";
      this.state.service_hrs_met = this.props.stu_entry.service_hrs_met ? "Yes" : "No";
      this.state.hw_rm_attended = this.props.stu_entry.hw_rm_attended ? "Yes" : "No";
      this.state.comments = this.props.stu_entry.comments;
    }
  }

  render() {
    const savingSnackbar = <Snackbar open={this.state.isSaving} message="Saving..." />;

    const marks = [
      {
        value: 0,
        label: "0"
      },
      {
        value: this.state.total_days,
        label: this.state.total_days,
      }
    ];

    return (
      <div>
        {/* toast that appears on error, shows up when all required fields are not filled in */}
        {this.state.error === true && (
          <Alert className="error" style={{}} severity="error">
            Please fill out all of the required fields
          </Alert>
        )}
        {/* toast that appears when student tries to make an entry when an entry has alreadt been made */}
        {this.state.pay_day_error === true && (
          <Alert className="error" style={{}} severity="error">
            You already have a historical entry on record for this pay period.
            Another entry for the same pay period cannot be created.
          </Alert>
        )}
        {/* toast that appears when api call fails */}
        {this.state.api_error === true && (
          <Alert className="error" style={{}} severity="error">
            An error occurred while attempting to send this data to the server.
            Please try again later.
          </Alert>
        )}

        <Grid container style={{ maxWidth: "90%", margin: "16px auto 8px auto" }}>
          <Grid item xs={1}>
            <IconButton onClick={() => this.state.backButtonFunc()}>
              <ArrowBackIcon fontSize="large" />
            </IconButton>
          </Grid>
          <Grid item xs={10}>
            <h6 style={{ textAlign: "center" }}>
              This entry is for the period of
            </h6>
            <h3 style={{ textAlign: "center" }}>
              {this.findCurrentPeriod()}
            </h3>
          </Grid>
        </Grid>
        <Paper
          elevation={5}
          style={{
            padding: "5%",
            marginLeft: "5%",
            marginRight: "5%",
            marginBottom: "5%",
          }}
        >
          {/* start form for make entry */}
          <form onSubmit={this.submitInfo} className="payday-entry-form">
            <FormControl component="fieldset">
              <FormLabel component="legend" style={{ color: "black" }}>
                1. Are you passing all your classes?
              </FormLabel>
              <RadioGroup
                required
                aria-label="pass_class"
                name="pass_class"
                // sets the value of the input to the value of state
                value={this.state.pass_class}
                // onChange run handleChange function to update coorasponding state
                onChange={(event) => this.handleChange(event, "pass_class")}
              >
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="Yes"
                  control={<GreenRadio />}
                  label="Yes"
                />
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="No"
                  control={<YellowRadio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
            <p>2. What is your current GPA?</p>
            <Form.Control
              style={{
                width: "10%",
              }}
              disabled={this.state.isSaving}
              required
              // sets the default value to the value of state
              defaultValue={this.state.gpa}
              type="number"
              valueLabelDisplay="auto"
              step={0.01}  // only allows steps of 0.01
              max={4}  // 4.0 gpa scale
              min={0}
              label="GPA"
              name="GPA"
              onChange={(event) => this.handleChange(event, "gpa")}
            />
            <br />

            <p>3. How many days do you have clean attendance?</p>
            <Slider
              style={{
                width: "80%",
              }}
              required
              // sets the default value of the input to the value of state
              defaultValue={this.state.days_clean_attend}
              type="number"
              aria-labelledby="discrete-slider-custom"
              step={1} //days are a whole number (no decimals)
              valueLabelDisplay="auto"
              max={this.state.total_days} //max of how many school days in that week, this varies by each week.
              min={0} //starts at 0 since you can't attend a negative amount of days
              label="days_clean_attend"
              name="days_clean_attend"
              // sets the value of the input to the value of state
              value={this.state.days_clean_attend}
              // onChange run handleChange function to update coorasponding state
              onChange={this.handleChangeCleanAttend}
              marks={marks} // sets the mark values below the slider.
            />{" "}
            <span style={{ marginLeft: 20 }}>
              Clean attendance: {this.state.days_clean_attend}
            </span>

            <br />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend" style={{ color: "black" }}>
                4. Do you have detention hours at school?
              </FormLabel>
              <RadioGroup //Yes or No answer (i.e. two options)
                aria-label="had_detention"
                name="had_detention"
                // sets the value of the input to the value of state
                value={this.state.had_detention}
                onChange={(event) => this.handleChange(event, "had_detention")}
              >
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="No"
                  control={<GreenRadio />}
                  label="No"
                />
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="Yes"
                  control={<YellowRadio />}
                  label="Yes"
                />
              </RadioGroup>
            </FormControl>{" "}
            <br />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend" style={{ color: "black" }}>
                5. Are you involved in any after school activity or job? <br />
                (At school or at Legacy)
              </FormLabel>
              <RadioGroup //Yes or No answer (i.e. two options)
                aria-label="act_or_job"
                name="act_or_job"
                // sets the value of the input to the value of state
                value={this.state.act_or_job}
                onChange={(event) => this.handleChange(event, "act_or_job")}
              >
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="Yes"
                  control={<GreenRadio />}
                  label="Yes"
                />
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="No"
                  control={<YellowRadio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
            <br />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend" style={{ color: "black" }}>
                6. Do you use illegal drugs or alcohol?
              </FormLabel>
              <RadioGroup //Yes or No answer (i.e. two options)
                aria-label="substance_abuse"
                name="substance_abuse"
                // sets the value of the input to the value of state
                value={this.state.substance_abuse}
                onChange={(event) => this.handleChange(event, "substance_abuse")}
              >
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="No"
                  control={<GreenRadio />}
                  label="No"
                />
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="Yes"
                  control={<YellowRadio />}
                  label="Yes"
                />
              </RadioGroup>
            </FormControl>
            <br />
            <br />
              <FormControl component="fieldset">
              <FormLabel component="legend" style={{ color: "black" }}>
                7. Have you completed 40 hours of community service this year?
              </FormLabel>
              <RadioGroup //Yes or No answer (i.e. two options)
                aria-label="service_hrs_met"
                name="service_hrs_met"
                // sets the value of the input to the value of state
                value={this.state.service_hrs_met}
                onChange={(event) => this.handleChange(event, "service_hrs_met")}
              >
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="Yes"
                  control={<GreenRadio />}
                  label="Yes"
                />
                <FormControlLabel
                  disabled={this.state.isSaving}
                  value="No"
                  control={<YellowRadio />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
            <br />
            <br />
            <FormControl component="fieldset">
              <FormLabel component="legend" style={{ color: "black" }}>
                8. Did you attend the Hub this pay period?
              </FormLabel>
              <RadioGroup //Yes or No answer (i.e. two possible options)
                aria-label="hw_rm_attended"
                name="hw_rm_attended"
                // sets the value of the input to the value of state
                value={this.state.hw_rm_attended}
                //onChange of input values set local state
                onChange={(event) => this.handleChange(event, "hw_rm_attended")}
              >
                <FormControlLabel
                  value="Yes"
                  control={<GreenRadio />} //colors button
                  label="Yes"
                  disabled={this.state.isSaving}
                />
                <FormControlLabel
                  value="No"
                  control={<YellowRadio />} //colors button
                  label="No"
                  disabled={this.state.isSaving}
                />
              </RadioGroup>
            </FormControl>{" "}
            <br /> <br />
            <p>9. Any comments you would like to leave this pay period?</p>
            <TextField //box for student to enter in text
              style={{
                backgroundColor: "white",
                margin: "5px",
                width: "100%",
              }}
              disabled={this.state.isSaving}
              //per material UI changes textfield to act like a textarea tag
              multiline
              //input field takes up for rows by defaults
              minRows={4}
              //...will expand up to 8 rows
              maxRows={8}
              variant="outlined"
              fullWidth
              label="Write comments here"
              name="comments"
              // sets value of input to local state
              value={this.state.comments}
              type="text"
              maxLength={1000}
              //onChange of input values set local state
              onChange={(event) => this.handleChange(event, "comments")} //onChange of input values set local state
            />{" "}
            <center>
              <Button
                disabled={this.state.isSaving}
                variant="contained"
                className="button"
                onClick={() => this.state.backButtonFunc()}>
                Cancel Entry
              </Button>

              <Button
                disabled={this.state.isSaving}
                variant="contained"
                type="submit"
                color="primary"
                className="button">
                Submit Entry
              </Button>
            </center>
          </form>
        </Paper>
        <br />{" "}
        {/*Add a little buffer on the bottom of page (prevent cutoff on mobile) */}
        <br />
        { savingSnackbar }
      </div>
    );
  }

  //This function handles storing input values into state on change
  handleChange = (event, fieldName) => {
    this.setState({ [fieldName]: event.target.value });
  };

  handleChangeCleanAttend = (event, days_clean_attend) => {
    days_clean_attend = Number(days_clean_attend);
    this.setState({
      days_clean_attend,
    });
  };

  //this function sends user information to the server to store in the database
  submitInfo = (event) => {
    event.preventDefault();
    const {
      pass_class,
      lcf_id,
      gpa,
      days_clean_attend,
      had_detention,
      act_or_job,
      substance_abuse,
      service_hrs_met,
      hw_rm_attended,
      comments,
    } = this.state;
    //don't run function if any of these values below are null
    if (
      pass_class === null ||
      had_detention === null ||
      act_or_job === null ||
      substance_abuse === null ||
      service_hrs_met === null ||
      hw_rm_attended === null
    ) {
      this.setState({ error: true });
      setTimeout(() => this.setState({ error: false }), 5000);
      return;
    }

    SwalJsx.fire({
      title: "Please confirm details below",
      html: this.buildEntryPreview(this.state),
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#5cb85c",
      cancelButtonColor: "#fcb70a",
      confirmButtonText: "Confirm my entry",
    }).then((result) => {
      if (!result.value) {
        return;
      }
      this.setState({ isSaving: true });
      const payload = {
        pay_day: this.findCurrentPayDay().format("YYYY-MM-DD"),
        pass_class: pass_class === "Yes" ? true : false,
        lcf_id: lcf_id,
        gpa: gpa,
        days_clean_attend: days_clean_attend,
        had_detention: had_detention === "Yes" ? true : false,
        act_or_job: act_or_job === "Yes" ? true : false,
        substance_abuse: substance_abuse === "Yes" ? true : false,
        service_hrs_met: service_hrs_met === "Yes" ? true : false,
        hw_rm_attended: hw_rm_attended === "Yes" ? true : false,
        comments: comments
      };

      if (this.props.stu_entry) {  // PUT (not post)
        axios.put(
          `/api/student/updateentry/${this.state.lcf_id}/${this.state.entry_id}`,
          payload)
          .then(() => {
            this.setState({ isSaving: false });
            Swal.fire("Success!", "Your entry has been saved.", "success");
            this.state.backButtonFunc({
              gpa: this.state.gpa,
              id: this.state.entry_id,
              days_clean_attend: this.state.days_clean_attend,
              pass_class: this.state.pass_class === "Yes" ? true : false,
              had_detention: this.state.had_detention === "Yes" ? true : false,
              act_or_job: this.state.act_or_job === "Yes" ? true : false,
              substance_abuse: this.state.substance_abuse === "Yes" ? true : false,
              service_hrs_met: this.state.service_hrs_met === "Yes" ? true : false,
              hw_rm_attended: this.state.hw_rm_attended === "Yes" ? true : false,
              comments: this.state.comments,
            });
          })
          .catch((error) => {
            console.log("Error saving entry: ", error);
            this.setState({ isSaving: false });
            this.setState({ api_error: true });
            setTimeout(() => this.setState({ api_error: false }), 5000);
          });
      } else {  // not updating, POST (not put)
        axios.post("/api/entry", payload)
          .then(() => {
            this.setState({ isSaving: false });
            Swal.fire("Success!", "Your entry has been saved.", "success");
            this.state.backButtonFunc(true);  // go back to home
          })
          .catch((error) => {
            console.log("Error saving entry: ", error);
            this.setState({ isSaving: false });
            this.setState({ api_error: true });
            setTimeout(() => this.setState({ api_error: false }), 5000);
          });
      }

    });
  };

  buildEntryPreview(entry) {
    const hasAttendanceInfo = typeof (entry.days_clean_attend) !== 'undefined';
    let attendHtml;
    if (hasAttendanceInfo) {
      attendHtml = (<div>
        <div>3. Days with clean attendance: {entry.days_clean_attend}</div>
      </div>);
    }
    return (<div className="payday-swal-content">
      <div>1. Passing classes: {entry.pass_class}</div>
      <div>2. GPA: {entry.gpa}</div>
      {attendHtml}
      <div>4. Had detention hours: {entry.had_detention}</div>
      <div>5. Job or after school activities: {entry.act_or_job}</div>
      <div>6. Illegal drugs or alcohol: {entry.substance_abuse}</div>
      <div>7. 40 or more service hours: {entry.service_hrs_met}</div>
      <div>8. Hub attendence: {entry.hw_rm_attended}</div>
      <div>9. Comments: {entry.comments}</div>
    </div>);
  }

  findCurrentPeriod() {
    let today = moment();
    let previous_pay_day = moment("2020-09-21T00:00:00.000-05"); //midnight central time
    let pay_day = moment(previous_pay_day);
    let counter = 0;
    while (today >= pay_day) {
      counter++;
      previous_pay_day = pay_day;
      pay_day = moment(previous_pay_day).add(2, "week");
    }
    const period_start = moment(pay_day).add(-2, "week").format('MMMM Do');
    const period_end = moment(pay_day).add(-1, "day").format('MMMM Do');
    return period_start + " - " + period_end;
  }

  findCurrentPayDay() {
    let today = moment();
    let previous_pay_day = moment("2020-09-21T00:00:00.000-05"); //midnight central time
    let pay_day = moment(previous_pay_day);
    while (today >= pay_day) {
      previous_pay_day = pay_day;
      pay_day = moment(previous_pay_day).add(2, "week");
    }
    return pay_day;
  }

}

const mapStateToProps = (state) => ({

});

export default withRouter(connect(mapStateToProps)(EntryForm));
